import { createAction, props } from '@ngrx/store';
import { HttpParamObject } from '../../../shared/data-types/http-types';
import { FileModel } from '../../models/file/file.model';

export const fetchFileList = createAction(
  '[Files] Fetch Files',
  props<{
    payload: {
      params: HttpParamObject;
    };
  }>(),
);

export const setFiles = createAction(
  '[Files] Set Files',
  props<{
    payload: FileModel[];
  }>(),
);

export const fetchSingleFile = createAction(
  '[Files] Fetch Single File',
  props<{
    payload: {
      params: HttpParamObject;
      downloadToDisk: boolean;
    };
  }>(),
);

export const setSingleFile = createAction(
  '[Files] Set Single File',
  props<{ payload: FileModel }>(),
);

export const downloadPdf = createAction(
  '[Files] Download File',
  props<{ payload: { blob: Blob; fileName: string } }>(),
);

export const uploadFile = createAction(
  '[Files] Upload File',
  props<{ payload: { fileModel: FileModel; params: HttpParamObject } }>(),
);
export const fileUploaded = createAction(
  '[Files] File Uploaded',
  props<{ payload: FileModel; showNotification: boolean }>(),
);

export const uploadProgressSet = createAction(
  '[Files] Upload Progress Set',
  props<{ payload: { uploadId: number; progress: number } }>(),
);

export const updateFile = createAction(
  '[Files] Update File',
  props<{
    payload: {
      toBeDeletedParams: HttpParamObject;
      fileModel: FileModel;
      toBeUpdatedParams: HttpParamObject;
    };
  }>(),
);
export const fileUpdated = createAction(
  '[Files] File Updated',
  props<{ payload: FileModel; showNotification: boolean }>(),
);

export const deleteFile = createAction(
  '[Files] Delete File',
  props<{ payload: HttpParamObject }>(), // use only one (string or number) depending on your file id type
);
export const fileDeleted = createAction(
  '[Files] File Deleted',
  props<{ payload: FileModel; showNotification: boolean }>(),
);

export const httpFail = createAction('[Files] Http fail', props<{ payload: string }>());
